import axios from './../../config/axios';

function newCustomersPerMonth() {
    return axios().get("/sales/chart/new-customers-per-month");
}

function newCustomersPerWeek() {
    return axios().get("/sales/chart/new-customers-per-week");
}

function topCustomersOverall() {
    return axios().get("/sales/chart/top-customers-overall")
}

function topCustomersPerMonth() {
    return axios().get("/sales/chart/top-customers-monthly")
}

function paymentMonthly() {
    return axios().get("/sales/chart/payment-monthly");
}

function paymentWeekly() {
    return axios().get("/sales/chart/payment-weekly");
}


export default {
    newCustomersPerMonth,
    topCustomersOverall,
    paymentMonthly,
    paymentWeekly,
    newCustomersPerWeek,
    topCustomersPerMonth
}